import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { Slot } from '@radix-ui/react-slot';
import { Loader2 } from 'lucide-react';
import { cn } from '@/core/utils/cn';
const buttonVariants = cva('inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition active:scale-[0.98] disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-none', {
    variants: {
        variant: {
            primary: 'bg-primary text-primary-contrast hover:bg-primary-hover active:bg-primary-pressed',
            secondary: 'bg-surface text-text-primary border border-border hover:bg-surface-2',
            ghost: 'text-primary hover:bg-primary-light',
            danger: 'bg-danger text-white hover:opacity-90',
            link: 'text-info underline-offset-4 hover:underline',
        },
        size: {
            sm: 'h-8 px-3 text-xs',
            md: 'h-10 px-4 text-sm',
            lg: 'h-11 px-6 text-base',
            icon: 'h-9 w-9',
        },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
});
export const Button = forwardRef(({ className, variant, size, asChild, cargando, children, disabled, type, ...props }, ref) => {
    const classes = cn(buttonVariants({ variant, size }), className);
    // asChild: Slot exige un único hijo React — nunca inyectamos spinner.
    if (asChild) {
        return (_jsx(Slot, { ref: ref, className: classes, ...props, children: children }));
    }
    return (_jsxs("button", { ref: ref, type: type ?? 'button', disabled: disabled || cargando, className: classes, ...props, children: [cargando ? _jsx(Loader2, { className: "h-4 w-4 animate-spin" }) : null, children] }));
});
Button.displayName = 'Button';
